import { atom } from 'jotai';

export const addressEntryManualDialogOpenAtom = atom<boolean>(false);

export const addressEntryManualDialogTabAtom = atom<number>(0);

export const addressEntryDedicatedNmiSearchDialogOpenAtom = atom<boolean>(false);

export const addressConfirmDialogOpenAtom = atom<boolean>(false);

export const addressManualDialogWithTabAtom = atom(
  (get) => get(addressEntryManualDialogOpenAtom),
  (get, set, isOpen: boolean, tabIndex?: number) => {
    set(addressEntryManualDialogOpenAtom, isOpen);
    set(addressEntryManualDialogTabAtom, tabIndex ?? 0);
  }
);
